import { List, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import CheckQuerySummaryLookup from '../Models/Lookups/CheckQuerySummaryLookup';
import EmailAddress from '../Models/Lookups/EmailAddress';

@NeoModel
export default class ManageCheckQueryConfigComponentVM extends Views.ViewModelBase {
    public managedCheckQueryConfig = new CheckQuerySummaryLookup();
    public emailAddressesList = new List(EmailAddress);
    public showManagedComponent: boolean = false;
    public showConfirmationModal: boolean = false;
    public initImportProcessStepValue: number = 0;



    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public checkQueryApiClient  = AppService.get(Types.ApiClients.CheckQueryApiClient),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
    }

    public async initialise() { 
        this.setUpManagedObject();
        this.loadEmailAddresses();
        this.showManagedComponent = true;
    }

    public setUpManagedObject(){
        if(this.managedCheckQueryConfig.runFrequency !== null)
        {
            this.managedCheckQueryConfig.runFrequency = this.managedCheckQueryConfig.runFrequency*60;
        }
        if(this.managedCheckQueryConfig.importProcessStepId !== 0)
        {
            this.initImportProcessStepValue = this.managedCheckQueryConfig.importProcessStepId;
        }
    }

    public loadEmailAddresses() {
        this.emailAddressesList = new List(EmailAddress);
        if(this.managedCheckQueryConfig.emailAddresses !== "" && this.managedCheckQueryConfig.emailAddresses !== null)
        {
            this.managedCheckQueryConfig.emailAddresses.split(';').forEach(x => this.emailAddressesList.push(new EmailAddress(x)))
        }   
    }

    public onCheckQueryItemSelected(item: string | undefined)
    {
        this.managedCheckQueryConfig.checkQueryDescription = (item == null ? "" : item);
    }

    public updateManagedObjectBeforeValidation() {
        this.managedCheckQueryConfig.emailAddressesList = [];
        this.managedCheckQueryConfig.emailAddressesList = this.emailAddressesList.map(i => i.emailAddress);
        this.managedCheckQueryConfig.emailAddresses = this.managedCheckQueryConfig.emailAddressesList.join(';');

        if(this.initImportProcessStepValue !== 0 && this.initImportProcessStepValue !== this.managedCheckQueryConfig.importProcessStepId
            && this.managedCheckQueryConfig.isValid && this.managedCheckQueryConfig.checkQueryId !== 0)
        {
            this.showConfirmationModal = true;
        }
    }
}